import { Swords } from "lucide-react";
import type { LadderView } from "../types";

export function LadderChallenge({
  view,
  busy,
  onChallenge,
}: {
  view: LadderView | null;
  busy: boolean;
  onChallenge: () => void;
}) {
  const opponents = (view?.entries ?? []).filter((entry) => entry.userId !== view?.self?.userId);
  const unavailable = !view
    ? "正在读取天梯"
    : !view.self
      ? "请先保存对战配置"
      : view.used >= view.limit
        ? "今日挑战次数已用完"
        : opponents.length === 0
          ? "暂无可挑战的对手"
          : "";
  return (
    <div className="ladder-challenge">
      <button
        className="primary-command compact"
        disabled={busy || !!unavailable}
        onClick={() => {
          if (!busy && !unavailable) onChallenge();
        }}
      >
        <Swords size={16} />
        开始匹配
      </button>
      {unavailable && <small role="status">{unavailable}</small>}
    </div>
  );
}
